export default "__VITE_ASSET__yXO6zaYb__"